import Timer from "../timer";
import { Tween } from "../tween";
import Contract from "./contract";
import Parallel from "./parallel";
import Sequence from "./sequence";

export type Cancellable = Contract<any> | Tween | number;

export default class CancelGroup {

    private group: Cancellable[] = [];

    public parallel<T>(methods: Array<() => Contract<T>>): Parallel<T> {
        return this.add(new Parallel(methods));
    }

    public sequence<T>(methods: Array<() => Contract<T>>): Sequence<T> {
        return this.add(new Sequence(methods));
    }

    public contract<T>(method: () => any): Contract<T> {
        return this.add(new Contract(method));
    }

    public timeout<T>(callback: () => T, duration: number): number {
        return this.add(Timer.setTimeout(callback, duration));
    }

    public interval<T>(callback: () => T, duration: number): number {
        return this.add(Timer.setInterval(callback, duration));
    }

    public tween(object: any): Tween {
        return this.add(new Tween(object));
    }

    public add(item: Cancellable): Cancellable {
        this.group.push(item);
        return item;
    }

    public cancel(): void {
        while (this.group.length) {
            const cancellable: Cancellable = this.group.shift();
            if (cancellable instanceof Tween) {
                cancellable.stop();
            } else if (cancellable instanceof Contract) {
                cancellable.cancel();
            } else if (typeof cancellable === "number") {
                Timer.clearInterval(cancellable);
                Timer.clearTimeout(cancellable);
            }
        }
    }

    public clear(): void {
        this.group = [];
    }
}
